import type { PropsWithChildren, ReactNode } from "react";

import type { IIconName } from "@components/icon";

export enum ITooltipSizeEnum {
  "X_Small" = "x-small",
  "2X_Small" = "2x-small",
  Large = "large",
}

export enum ITooltipPositionEnum {
  Top = "top",
  Left = "left",
  Right = "right",
  Bottom = "bottom",
}

export interface ITooltipProps extends PropsWithChildren {
  title: string | ReactNode;
  description?: string;
  icon?: IIconName;
  size?: ITooltipSizeEnum;
  position?: ITooltipPositionEnum;
  className?: string;
  contentClassName?: string;
}
